import script from "./ThemeImages.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeImages.vue?vue&type=script&setup=true&lang=js"

import "./ThemeImages.vue?vue&type=style&index=0&id=a1b15072&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1b15072"]])

export default __exports__